import { YoutubeFilled } from "@ant-design/icons";
import { message } from "antd";
import { useEffect } from "react";
import  { studioApi } from "../../api";

export default function YoutubeConnectCard() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const youtubeStatus = params.get("youtube");
    if (youtubeStatus === "connected") {
      message.success("YouTube connected successfully");
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
    }

    if (youtubeStatus === "error") {
      message.error("Failed to connect YouTube");

      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
    }
  }, []);

  const handleConnectYoutube = async () => {
    try {
      const { data } = await studioApi.get(
        "/youtube/auth-url"
      );
  
      if (data?.url) {
        window.location.href = data.url;
      } else {
        message.error("OAuth URL not received");
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to connect YouTube"
      );
    }
  };

  return (
    <div className="w-[280px] rounded-[16px] border border-gray-200 bg-white p-1 shadow-[0_2px_10px_rgba(15,23,42,0.05)]">
    <div className="flex items-center" />
    <div className="p-[2px] m-[3px]">
      <div className="mb-[14px] flex items-center gap-[12px]">
        <div className="flex h-[42px] w-[42px] items-center justify-center rounded-[10px] border border-gray-200 bg-white">
          <YoutubeFilled className="text-[20px] text-[#ff0000]" />
        </div>
        <div>
          <div className="text-[14px] font-semibold text-gray-900">
            Connect Channel
          </div>
          <div className="mt-[2px] text-[12px] text-slate-500">
            Secure OAuth integration
          </div>
        </div>
      </div>

      <p className="mb-[10px] text-[13px] leading-[1.7] text-slate-500">
        Connect your YouTube account to create, schedule, and manage live streaming
        sessions directly from the studio dashboard.
      </p>

      <button
        onClick={handleConnectYoutube}
        className="flex h-[46px] w-full items-center justify-center gap-[10px] rounded-[12px] bg-[#ff0000] text-[14px] font-semibold text-white shadow-[0_8px_18px_rgba(255,0,0,0.18)] hover:bg-[#e60000] transition-colors"
      >
        <YoutubeFilled />
        <span>Connect YouTube</span>
      </button>
    </div>
  </div>
  );
}